import Product from './Product';
import { useState, useEffect } from 'react';

function AllProduct({
  result,
  convRatio,
  product,
  drawingBaseDimensions,
  pause = false,
}) {
  const throughput = product['throughput'];
  const speed = drawingBaseDimensions.centerline_speed;
  const trackLength =
    (drawingBaseDimensions.nbr_windings *
      drawingBaseDimensions.central_diam *
      Math.PI) /
    Math.cos((drawingBaseDimensions.slope_angle_center / 180) * Math.PI);
  const nbrProduct = ((trackLength / 1000) * throughput) / speed || 1;
  const x = Math.ceil(nbrProduct);

  const [t, setT] = useState(0);
  const transDirSource = drawingBaseDimensions.transport_direction;
  const transDirFactor = transDirSource === 'transport down' ? -1 : 1;

  useEffect(() => {
    let animationFrameId;

    const animate = () => {
      setT((prevT) => {
        const newT =
          prevT + (transDirFactor * (speed * 1000)) / 60 / trackLength / 60;
        return newT > 1 ? 0 : newT < 0 ? 1 : newT;
      });
      animationFrameId = requestAnimationFrame(animate);
    };

    if (!pause) {
      animationFrameId = requestAnimationFrame(animate);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, [speed, pause, transDirFactor, product]);

  return (
    <>
      {Array.from({ length: x }).map((_, i) => {
        const productT = (t + i / x) % 1;
        return (
          <Product
            key={i}
            result={result}
            convRatio={convRatio}
            product={product}
            drawingBaseDimensions={drawingBaseDimensions}
            t={productT}
          />
        );
      })}
    </>
  );
}

export default AllProduct;
